import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { LogService } from '../../../_shared/log.service'
import { CollegeService } from '@app/_services/masters/college.service';
import { first } from 'rxjs/operators';
import { college } from '@app/_models/college';
import { Subject } from 'rxjs';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-college-master',
  templateUrl: './college-master.component.html',
  styleUrls: ['./college-master.component.css']
})
export class CollegeMasterComponent implements OnInit {

  college: college[];
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  getresponse: any;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  collegeId: number;
  delMessage: string;

  constructor(private modalService: NgbModal, config: NgbModalConfig, private eventService: LogService, private collegeService: CollegeService) { }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.collegeService.getCollege()
      .pipe(first())
      .subscribe(
        data => {
          console.log("document response---", data)
          this.college = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }



  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('13');
  }

  deleteCollege(id) {
    this.collegeId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteColeg() {
    this.collegeService.deleteCollege(this.collegeId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("College response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            this.collegeService.getCollege()
              .pipe(first())
              .subscribe(
                data => {
                  this.delMessage="College Deleted Successfully."
                  console.log("College response---", data)
                  this.college = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
          //this.modalService.dismissAll(this.showModalDeleteBoxTemplate);

          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }


}
